import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { FeatureRouteGuard } from '~/components/route-guards'
import { useTicketDetail } from '~/components/routes/service-client/service-client-api'
import { SERVICE_CLIENT_TICKET_READ } from '~/components/routes/service-client/service-client-rights'
import { TicketDetailView } from '~/components/routes/service-client/ticket-detail'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/service-client/tickets/$id')({
  staticData: {
    permission: SERVICE_CLIENT_TICKET_READ,
  },
  component: TicketDetailRoute,
})

withRoutePermissions(Route)

function TicketDetailRoute() {
  return (
    <FeatureRouteGuard flag={FLAGS.serviceClientSidebar}>
      <TicketDetailPage />
    </FeatureRouteGuard>
  )
}

function TicketDetailPage() {
  const { id } = Route.useParams()
  const navigate = useNavigate()
  const { detail, isPending } = useTicketDetail(Number(id))

  const goBack = () => navigate({ to: '/service-client', search: { tab: 'inbox' } })

  return (
    <>
      <AppHeader>
        <Title>Service client</Title>
      </AppHeader>
      <AppContainer>
        {detail ? (
          <TicketDetailView detail={detail} onBack={goBack} />
        ) : (
          <p className="mt-6 text-sm text-muted-foreground">
            {isPending ? 'Chargement…' : 'Ticket introuvable.'}
          </p>
        )}
      </AppContainer>
    </>
  )
}
